<div [ngClass]="classList">
  <app-select
    [label]="label"
    [aria-label]="ariaLabel"
    [items]="items"
    [selected]="selected"
    (selectionChanged)="onSelectionChanged($event)">
  </app-select>
</div>
